'use client';

import Link from 'next/link';
import { useAuth } from '@/hooks/useAuth';

export default function LpHeaderNav() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return (
      <Link
        href="/user/dashboard"
        className="rounded-full bg-primary px-4 py-2.5 text-center text-xs font-bold text-white transition-opacity hover:opacity-60 md:px-5 md:py-2 md:text-sm"
      >
        マイページ
      </Link>
    );
  }

  return (
    <div className="flex items-center gap-3 md:gap-4">
      <Link
        href="/user/login"
        className="rounded-full border border-mono-100 px-4 py-2.5 text-center text-xs font-bold text-mono-100 transition-opacity hover:opacity-60 md:px-5 md:py-2 md:text-sm"
      >
        ログイン
      </Link>
      <Link
        href="/user/signup"
        className="block rounded-full bg-primary px-4 py-2.5 text-center text-xs font-bold text-white transition-opacity hover:opacity-60 md:px-5 md:py-2 md:text-sm"
      >
        会員登録
      </Link>
    </div>
  );
}
